export const GET_LIST_PACKAGE_REQUEST = 'GET_LIST_PACKAGE_REQUEST'
export const GET_LIST_PACKAGE_SUCCESS = 'GET_LIST_PACKAGE_SUCCESS'
export const GET_LIST_PACKAGE_FAIL = 'GET_LIST_PACKAGE_FAIL'
export const DELETE_LIST_PACKAGE_REQUEST = 'DELETE_LIST_PACKAGE_REQUEST'
export const DELETE_LIST_PACKAGE_SUCCESS = 'DELETE_LIST_PACKAGE_SUCCESS'
export const DELETE_LIST_PACKAGE_FAIL = 'DELETE_LIST_PACKAGE_FAIL'
export const DUPLICATE_LIST_PACKAGE_REQUEST = 'DUPLICATE_LIST_PACKAGE_REQUEST'
export const DUPLICATE_LIST_PACKAGE_SUCCESS = 'DUPLICATE_LIST_PACKAGE_SUCCESS'
export const DUPLICATE_LIST_PACKAGE_FAIL = 'DUPLICATE_LIST_PACKAGE_FAIL'
export const CREATE_PACKAGE_REQUEST = 'CREATE_PACKAGE_REQUEST'
export const CREATE_PACKAGE_SUCCESS = 'CREATE_PACKAGE_SUCCESS'
export const CREATE_PACKAGE_FAIL = 'CREATE_PACKAGE_FAIL'
export const UPDATE_PACKAGE_REQUEST = 'UPDATE_PACKAGE_REQUEST'
export const UPDATE_PACKAGE_SUCCESS = 'UPDATE_PACKAGE_SUCCESS'
export const UPDATE_PACKAGE_FAIL = 'UPDATE_PACKAGE_FAIL'
export const GET_PACKAGE_REQUEST = 'GET_PACKAGE_REQUEST'
export const GET_PACKAGE_SUCCESS = 'GET_PACKAGE_SUCCESS'
export const GET_PACKAGE_FAIL = 'GET_PACKAGE_FAIL'

// ** Package Service Constant
export const GET_LIST_PACKAGE_SERVICE_REQUEST = 'GET_LIST_PACKAGE_SERVICE_REQUEST'
export const GET_LIST_PACKAGE_SERVICE_SUCCESS = 'GET_LIST_PACKAGE_SERVICE_SUCCESS'
export const GET_LIST_PACKAGE_SERVICE_FAIL = 'GET_LIST_PACKAGE_SERVICE_FAIL'

export const GET_LIST_PACKAGE_SERVICE_SUMMARY_REQUEST = 'GET_LIST_PACKAGE_SERVICE_SUMMARY_REQUEST'
export const GET_LIST_PACKAGE_SERVICE_SUMMARY_SUCCESS = 'GET_LIST_PACKAGE_SERVICE_SUMMARY_SUCCESS'
export const GET_LIST_PACKAGE_SERVICE_SUMMARY_FAIL = 'GET_LIST_PACKAGE_SERVICE_SUMMARY_FAIL'

export const GET_LIST_PACKAGE_SERVICE_ITEM_REQUEST = 'GET_LIST_PACKAGE_SERVICE_ITEM_REQUEST'
export const GET_LIST_PACKAGE_SERVICE_ITEM_SUCCESS = 'GET_LIST_PACKAGE_SERVICE_ITEM_SUCCESS'
export const GET_LIST_PACKAGE_SERVICE_ITEM_FAIL = 'GET_LIST_PACKAGE_SERVICE_ITEM_FAIL'

export const GET_LIST_PACKAGE_SERVICE_BY_SERVICE_ID_REQUEST = 'GET_LIST_PACKAGE_SERVICE_BY_SERVICE_ID_REQUEST'
export const GET_LIST_PACKAGE_SERVICE_BY_SERVICE_ID_SUCCESS = 'GET_LIST_PACKAGE_SERVICE_BY_SERVICE_ID_SUCCESS'
export const GET_LIST_PACKAGE_SERVICE_BY_SERVICE_ID_FAIL = 'GET_LIST_PACKAGE_SERVICE_BY_SERVICE_ID_FAIL'

export const ADD_LIST_PACKAGE_SERVICE_REQUEST = 'ADD_LIST_PACKAGE_SERVICE_REQUEST'
export const ADD_LIST_PACKAGE_SERVICE_SUCCESS = 'ADD_LIST_PACKAGE_SERVICE_SUCCESS'
export const ADD_LIST_PACKAGE_SERVICE_FAIL = 'ADD_LIST_PACKAGE_SERVICE_FAIL'

export const DELETE_LIST_PACKAGE_SERVICE_REQUEST = 'DELETE_LIST_PACKAGE_SERVICE_REQUEST'
export const DELETE_LIST_PACKAGE_SERVICE_SUCCESS = 'DELETE_LIST_PACKAGE_SERVICE_SUCCESS'
export const DELETE_LIST_PACKAGE_SERVICE_FAIL = 'DELETE_LIST_PACKAGE_SERVICE_FAIL'

// ** Package Additional Info
export const LIST_PACKAGE_ADDITIONAL_INFO_REQUEST = 'LIST_PACKAGE_ADDITIONAL_INFO_REQUEST'
export const LIST_PACKAGE_ADDITIONAL_INFO_SUCCESS = 'LIST_PACKAGE_ADDITIONAL_INFO_SUCCESS'
export const LIST_PACKAGE_ADDITIONAL_INFO_FAIL = 'LIST_PACKAGE_ADDITIONAL_INFO_FAIL'

export const LIST_SERVICE_ADDITIONAL_INFO_PACKAGE_REQUEST = 'LIST_SERVICE_ADDITIONAL_INFO_PACKAGE_REQUEST'
export const LIST_SERVICE_ADDITIONAL_INFO_PACKAGE_SUCCESS = 'LIST_SERVICE_ADDITIONAL_INFO_PACKAGE_SUCCESS'
export const LIST_SERVICE_ADDITIONAL_INFO_PACKAGE_FAIL = 'LIST_SERVICE_ADDITIONAL_INFO_PACKAGE_FAIL'

export const ADD_PACKAGE_ADDITIONAL_INFO_REQUEST = 'ADD_PACKAGE_ADDITIONAL_INFO_REQUEST'
export const ADD_PACKAGE_ADDITIONAL_INFO_SUCCESS = 'ADD_PACKAGE_ADDITIONAL_INFO_SUCCESS'
export const ADD_PACKAGE_ADDITIONAL_INFO_FAIL = 'ADD_PACKAGE_ADDITIONAL_INFO_FAIL'

export const DELETE_PACKAGE_ADDITIONAL_INFO_REQUEST = 'DELETE_PACKAGE_ADDITIONAL_INFO_REQUEST'
export const DELETE_PACKAGE_ADDITIONAL_INFO_SUCCESS = 'DELETE_PACKAGE_ADDITIONAL_INFO_SUCCESS'
export const DELETE_PACKAGE_ADDITIONAL_INFO_FAIL = 'DELETE_PACKAGE_ADDITIONAL_INFO_FAIL'

export const UPDATE_PACKAGE_PROPERTIES_FORMAT_OPTION_REQUEST = 'UPDATE_PACKAGE_PROPERTIES_FORMAT_OPTION_REQUEST'
export const UPDATE_PACKAGE_PROPERTIES_FORMAT_OPTION_SUCCESS = 'UPDATE_PACKAGE_PROPERTIES_FORMAT_OPTION_SUCCESS'
export const UPDATE_PACKAGE_PROPERTIES_FORMAT_OPTION_FAIL = 'UPDATE_PACKAGE_PROPERTIES_FORMAT_OPTION_FAIL'

export const RESET_PACKAGE_ADDITIONAL_INFO_AND_MEDICAL_INFO = 'RESET_PACKAGE_ADDITIONAL_INFO_AND_MEDICAL_INFO'